import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PatienthomeComponent } from './patienthome.component';
import { ModuleWithProviders, NgModule } from '@angular/core';
import {AppRoutingModule} from '../app.routing';
import { DelpatComponent } from './delpat/delpat.component'
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');  // Path to translation files
}

@NgModule({
    imports: [
      AppRoutingModule,
      CommonModule,
      HttpClientModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
    ],
    declarations: [
        PatienthomeComponent,
        DelpatComponent
    ],
  
    providers: [

    ]
  })
export class homeModule {}